namespace GeniuzPOS.PosShift {
    export interface PsPosShiftControlViewForm {
        ShiftStatus: Serenity.StringEditor;
    }

    export class PsPosShiftControlViewForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsPosShiftControlView';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosShiftControlViewForm.init)  {
                PsPosShiftControlViewForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsPosShiftControlViewForm, [
                    'ShiftStatus', w0
                ]);
            }
        }
    }
}
